import React, { useEffect } from "react";
import KnotMobile from "../../assets/png/knot-mobile.webp";
import KnotWeb from "../../assets/png/knot.webp";
import Human from "../../assets/png/human.webp";

import LetterAnimation from "./animations/LetterAnimation";

const HeaderHome = () => {
  useEffect(() => {
    const preloadImage = (url) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = url;
      document.head.appendChild(link);
    };
    preloadImage(KnotMobile);
  }, []);

  return (
    <>
      <section
        className="bg-[#050B25] bg-human hidden lg:block"
        style={{
          backgroundImage: `url(${Human})`,
          backgroundSize: "1200px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="text-center max-w-[689px] mb-6 pt-[80px] mx-auto">
          <LetterAnimation
            className="lg:text-[148px]"
            text="Time to connect"
            delay={0.3}
          />
        </div>
        <div className="mt-20 max-w-[250px] mx-auto my-auto">
          <a
            className="bg-white text-bluecoming py-5 px-5 text-center mx-auto text-xl font-semibold rounded-[64px]"
            href="contactez-nous"
          >
            Contactez-nous 👋
          </a>
        </div>
        <div className="pl-10 max-w-[600px] mt-9 md:mx-auto">
          <img
            className="md:hidden"
            width={1024}
            height={982}
            src={KnotMobile}
            alt="img knot mobile"
          />
          <div className="flex justify-center">
            <img
              className="hidden mt-24 sm:block"
              width={2988}
              height={2508}
              src={KnotWeb}
              alt="img knot mobile"
            />
          </div>
        </div>
      </section>
      <section className="bg-[#050B25] bg-human lg:hidden xl:h-[1095px]">
        <div>
          <div className="text-center mb-7 pt-[72px]">
            <LetterAnimation
              text="
              Time to connect"
              delay={0.1}
            />
          </div>
          <div className="max-w-[250px] mx-auto my-auto">
            <a
              className="bg-white text-bluecoming py-5 px-5 text-center mx-auto text-xl font-semibold rounded-[64px]"
              href="contactez-nous"
            >
              Contactez-nous 👋
            </a>
          </div>
          <div className="pl-10 max-w-[600px] mt-9 md:mx-auto">
            <img
              className="md:hidden"
              src={KnotMobile}
              width={1024}
              height={982}
              alt="img knot mobile"
            />
            <div className="flex justify-center">
              <img
                className="hidden mt-40 md:block"
                width={2988}
                height={2508}
                src={KnotWeb}
                alt="img knot mobile"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeaderHome;
